import { ArticleHeading5, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../Link';
import { getFirstAdvantageIcon, getFirstAdvantageText } from './helpers';
import * as styles from './BrokerDescriptionModalContent.css';
import NewbuildingIcon from './icons/newbuilding.svg';
import DealIcon from './icons/deal.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var BrokerDescriptionModalContent = function BrokerDescriptionModalContent(_ref) {
  var isSelfEmployedInfoVisible = _ref.isSelfEmployedInfoVisible,
    landingUrl = _ref.landingUrl,
    onRewardInstructionLinkClick = _ref.onRewardInstructionLinkClick;
  var firstAdvantageIcon = getFirstAdvantageIcon(isSelfEmployedInfoVisible);
  var firstAdvantageText = getFirstAdvantageText(isSelfEmployedInfoVisible);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['heading'],
      children: /*#__PURE__*/_jsx(UIHeading2, {
        children: "\u041F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u043A\u0438 \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['advantage'],
        children: [/*#__PURE__*/_jsx("img", {
          className: styles['icon'],
          src: firstAdvantageIcon,
          title: "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E"
        }), /*#__PURE__*/_jsx(UIText1, {
          children: firstAdvantageText
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['advantage'],
        children: [/*#__PURE__*/_jsx("img", {
          className: styles['icon'],
          src: NewbuildingIcon,
          title: "\u041D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0430"
        }), /*#__PURE__*/_jsx(UIText1, {
          children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0416\u041A \u0438 \u0437\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u043F\u043E \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0446\u0435\u043D\u0435."
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['advantage'],
        children: [/*#__PURE__*/_jsx("img", {
          className: styles['icon'],
          src: DealIcon,
          title: "\u0421\u0434\u0435\u043B\u043A\u0430"
        }), /*#__PURE__*/_jsxs(UIText1, {
          children: ["\u041F\u0440\u043E\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u043A\u0443 \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0434\u043E 80% \u043E\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430.", '\n', /*#__PURE__*/_jsx(Link, {
            url: landingUrl,
            onClick: onRewardInstructionLinkClick,
            children: /*#__PURE__*/_jsx(ArticleHeading5, {
              children: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u043E\u0437\u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435"
            })
          })]
        })]
      })]
    })]
  });
};